import { GetUserGroupsConfigResponse, User } from "../api/dtos/dtos";
import { MapFilter } from "../contexts/data/MapContext";

export default function isCurrentGroupAdmin(userGroupsConfig: GetUserGroupsConfigResponse | undefined, user: User | null, filter: MapFilter) {
    if (!user){
        return false;
    }

    if (userGroupsConfig && userGroupsConfig.communityGroups){
        let currentGroup = userGroupsConfig.communityGroups.find(cg => cg.communityGroupId === filter.bySubmitter.communityGroupId);
        
        if (currentGroup?.adminUserId === user.id){
            return true;
        }
    }
    return false;
}